import { List, useTable } from "@refinedev/antd";
import { Table, Tag, Typography } from "antd";
import { Link } from "react-router";
import type { AuditLogItem } from "../../types";
import { fmtDateTime } from "../../utils";

const ACTION_COLOR: Record<string, string> = {
  admin_login: "blue", admin_logout: "default",
  create_test_subscription: "green", admin_reset_key: "orange",
  admin_revoke_subscription: "red", admin_unrevoke_subscription: "cyan",
  extend_subscription: "purple",
};

export const AuditLogList = () => {
  const { tableProps } = useTable<AuditLogItem>({
    syncWithLocation: true,
    pagination: { mode: "server", pageSize: 50 },
    sorters: { initial: [{ field: "id", order: "desc" }] },
  });

  return (
    <List title="Аудит-лог" breadcrumb={false}>
      <Table {...tableProps} rowKey="id" scroll={{ x: 1100 }}>
        <Table.Column dataIndex="id" title="ID" width={70} />
        <Table.Column dataIndex="created_at" title="Когда"
          render={fmtDateTime} />
        <Table.Column<AuditLogItem>
          title="Админ"
          render={(_, r) => (
            <Link to={`/users/${r.admin_id}`}>
              {r.admin_username ? `@${r.admin_username}` : `tg:${r.admin_id}`}
            </Link>
          )}
        />
        <Table.Column dataIndex="action" title="Действие"
          render={(a: string) => <Tag color={ACTION_COLOR[a] || "default"}>{a}</Tag>} />
        <Table.Column<AuditLogItem>
          title="Цель"
          render={(_, r) => r.target_user_id
            ? <Link to={`/users/${r.target_user_id}`}>tg:{r.target_user_id}</Link>
            : "—"}
        />
        <Table.Column<AuditLogItem>
          title="Подробности"
          render={(_, r) => (
            <Typography.Text style={{ fontSize: 12 }}>
              {Object.keys(r.payload).length > 0
                ? JSON.stringify(r.payload).slice(0, 80)
                : "—"}
            </Typography.Text>
          )}
        />
        <Table.Column dataIndex="ip" title="IP"
          render={(v: string | null) => v
            ? <Typography.Text code style={{ fontSize: 11 }}>{v}</Typography.Text>
            : "—"} />
      </Table>
    </List>
  );
};
